import { standardStringSchema } from "@/schemas"
import { z } from "zod"

const existingProviderSchema = z.object({
  id: standardStringSchema.min(1),
  kind: z.literal("existing"),
  name: standardStringSchema.min(1),
})

const pendingProviderSchema = z.object({
  kind: z.literal("pending"),
  name: standardStringSchema.min(1),
})

export const providerSelectionSchema = z.discriminatedUnion("kind", [
  existingProviderSchema,
  pendingProviderSchema,
])

export type ProviderSelection = z.infer<typeof providerSelectionSchema>

export const providerNamesMatch = (left: string, right: string): boolean =>
  left.trim().toLowerCase() === right.trim().toLowerCase()
